module.exports = __webpack_public_path__ + "static/media/dany_mqtt_protocol.64687d18.md";